import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import UniversityListPage from "./pages/UniversityListPage";
import UniversityApplicationForm from "./pages/UniversityApplicationForm";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/universities" element={<UniversityListPage />} />
        <Route path="/application/:slug" element={<UniversityApplicationForm />} />
      </Routes>
    </Router>
  );
}

export default App;
